<script>
export default {
  props: {
    tag: {
      type: String,
      required: false,
      default: 'em'
    }
  },
  data() {
    return {
      name: ''
    }
  },
  render(createElement) {
    return createElement(this.tag, this.name)
  },
  created() {
    this.getApplyName()
  },
  methods: {
    getApplyName() {
      this.$fetch('/api/OrganizationEnterprise/GetApplyName').then(result => {
        this.name = result
      })
    }
  }
}
</script>

